/* === tweaks-panel.jsx === */

// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;width:100%;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null
      ? keyOrEdits : { [keyOrEdits]: val };
    setValues((prev) => ({ ...prev, ...edits }));
    window.parent.postMessage({ type: '__edit_mode_set_keys', edits }, '*');
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability. If the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({ title = 'Tweaks', children }) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({ x: 16, y: 16 });
  const PAD = 16;

  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth, h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y)),
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);

  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);

  React.useEffect(() => {
    const onMsg = (e) => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);
      else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({ type: '__edit_mode_available' }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);

  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({ type: '__edit_mode_dismissed' }, '*');
  };

  const onDragStart = (e) => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX, sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = (ev) => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy),
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };

  if (!open) return null;
  return (
    <>
      <style>{__TWEAKS_STYLE}</style>
      <div ref={dragRef} className="twk-panel" data-noncommentable=""
           style={{ right: offsetRef.current.x, bottom: offsetRef.current.y }}>
        <div className="twk-hd" onMouseDown={onDragStart}>
          <b>{title}</b>
          <button className="twk-x" aria-label="Close tweaks"
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={dismiss}>✕</button>
        </div>
        <div className="twk-body">{children}</div>
      </div>
    </>
  );
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({ label, children }) {
  return (
    <>
      <div className="twk-sect">{label}</div>
      {children}
    </>
  );
}

function TweakRow({ label, value, children, inline = false }) {
  return (
    <div className={inline ? 'twk-row twk-row-h' : 'twk-row'}>
      <div className="twk-lbl">
        <span>{label}</span>
        {value != null && <span className="twk-val">{value}</span>}
      </div>
      {children}
    </div>
  );
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({ label, value, min = 0, max = 100, step = 1, unit = '', onChange }) {
  return (
    <TweakRow label={label} value={`${value}${unit}`}>
      <input type="range" className="twk-slider" min={min} max={max} step={step}
             value={value} onChange={(e) => onChange(Number(e.target.value))} />
    </TweakRow>
  );
}

function TweakToggle({ label, value, onChange }) {
  return (
    <div className="twk-row twk-row-h">
      <div className="twk-lbl"><span>{label}</span></div>
      <button type="button" className="twk-toggle" data-on={value ? '1' : '0'}
              role="switch" aria-checked={!!value}
              onClick={() => onChange(!value)}><i /></button>
    </div>
  );
}

function TweakRadio({ label, value, options, onChange }) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  const opts = options.map((o) => (typeof o === 'object' ? o : { value: o, label: o }));
  const idx = Math.max(0, opts.findIndex((o) => o.value === value));
  const n = opts.length;

  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag. Ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  const segAt = (clientX) => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor(((clientX - r.left - 2) / inner) * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };

  const onPointerDown = (e) => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = (ev) => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };

  return (
    <TweakRow label={label}>
      <div ref={trackRef} role="radiogroup" onPointerDown={onPointerDown}
           className={dragging ? 'twk-seg dragging' : 'twk-seg'}>
        <div className="twk-seg-thumb"
             style={{ left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
                      width: `calc((100% - 4px) / ${n})` }} />
        {opts.map((o) => (
          <button key={o.value} type="button" role="radio" aria-checked={o.value === value}>
            {o.label}
          </button>
        ))}
      </div>
    </TweakRow>
  );
}

function TweakSelect({ label, value, options, onChange }) {
  return (
    <TweakRow label={label}>
      <select className="twk-field" value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((o) => {
          const v = typeof o === 'object' ? o.value : o;
          const l = typeof o === 'object' ? o.label : o;
          return <option key={v} value={v}>{l}</option>;
        })}
      </select>
    </TweakRow>
  );
}

function TweakText({ label, value, placeholder, onChange }) {
  return (
    <TweakRow label={label}>
      <input className="twk-field" type="text" value={value} placeholder={placeholder}
             onChange={(e) => onChange(e.target.value)} />
    </TweakRow>
  );
}

function TweakNumber({ label, value, min, max, step = 1, unit = '', onChange }) {
  const clamp = (n) => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({ x: 0, val: 0 });
  const onScrubStart = (e) => {
    e.preventDefault();
    startRef.current = { x: e.clientX, val: value };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = (ev) => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return (
    <div className="twk-num">
      <span className="twk-num-lbl" onPointerDown={onScrubStart}>{label}</span>
      <input type="number" value={value} min={min} max={max} step={step}
             onChange={(e) => onChange(clamp(Number(e.target.value)))} />
      {unit && <span className="twk-num-unit">{unit}</span>}
    </div>
  );
}

function TweakColor({ label, value, onChange }) {
  return (
    <div className="twk-row twk-row-h">
      <div className="twk-lbl"><span>{label}</span></div>
      <input type="color" className="twk-swatch" value={value}
             onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}

function TweakButton({ label, onClick, secondary = false }) {
  return (
    <button type="button" className={secondary ? 'twk-btn secondary' : 'twk-btn'}
            onClick={onClick}>{label}</button>
  );
}

Object.assign(window, {
  useTweaks, TweaksPanel, TweakSection, TweakRow,
  TweakSlider, TweakToggle, TweakRadio, TweakSelect,
  TweakText, TweakNumber, TweakColor, TweakButton,
});


/* === solara-form.jsx === */
// Solara Living shared form runtime.
//
// Provides three things to every page that has a lead form:
//   - WizardForm        : the multi-step wizard used by the home page + 4 product pages
//   - FileUploadField   : <input type=file> with chips, validation, and visible state
//   - CommentUploadsStep: the final "anything we should see?" step that replaces
//                         the legacy time-slot picker (per session 1b spec)
//   - submitLead        : multipart POST helper that targets /api/submit.php
//   - useFormSession    : session_id + debounced /api/track.php tracking
//
// Loaded BEFORE any page-specific jsx so the page jsx can render <WizardForm/>
// without redefining wizard mechanics in five places.
//
// File limits are enforced both client- and server-side. The server source of
// truth is api/config.example.php (uploads.max_bytes / .max_files). Keep these
// in sync when bumping caps.

// --- CMS content lookup helpers (top-level so every page that loads this file
// can access them via bare `_C` / `_CA`). On the home page they're shadowed
// (redeclared) by the copies in solara-sections.jsx, harmless, second one
// wins. about-page.jsx defines its own copies because it does not load this
// file.
function _C(path, fallback){
  const root = (typeof window !== "undefined" && window.__SOLARA_CONTENT__) || (typeof globalThis !== "undefined" && globalThis.__SOLARA_CONTENT__) || null;
  if (!root) return fallback;
  const v = String(path).split('.').reduce((o, k) => (o == null ? o : o[k]), root);
  return (v === undefined || v === null || v === '') ? fallback : v;
}
function _CA(path, fallback){
  const v = _C(path, null);
  return Array.isArray(v) && v.length ? v : fallback;
}

(() => {
  const { useState, useEffect, useRef, useMemo, useCallback } = React;

  // --- Inject file-upload CSS once -------------------------------------------
  // The form-card/.field/.opts styles already live inline in every page HTML.
  // We only need to add the new classes introduced by FileUploadField, so we
  // inject a <style> tag the first time solara-form.jsx runs.
  if (typeof document !== 'undefined' && !document.getElementById('solara-form-css')) {
    const style = document.createElement('style');
    style.id = 'solara-form-css';
    style.textContent = `
      .field-files .files-help {
        font-size: 13px; color: var(--muted, #6b6258); margin: 4px 0 10px;
      }
      .field-files .files-list {
        display: flex; flex-wrap: wrap; gap: 8px; align-items: stretch;
      }
      .field-files .file-chip {
        display: inline-flex; align-items: center; gap: 8px;
        padding: 8px 10px 8px 14px;
        background: var(--bg-2, #efe7da); border-radius: 999px;
        font-size: 14px; max-width: 100%; color: var(--text, #2b2620);
      }
      .field-files .file-chip-name {
        max-width: 220px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
      }
      .field-files .file-chip-size {
        font-size: 12px; color: var(--muted, #6b6258);
      }
      .field-files .file-chip-remove {
        appearance: none; border: 0; background: transparent;
        width: 22px; height: 22px; border-radius: 50%;
        font-size: 17px; line-height: 1; color: var(--muted, #6b6258);
        cursor: pointer; display: inline-flex; align-items: center; justify-content: center;
        transition: background 120ms ease, color 120ms ease;
      }
      .field-files .file-chip-remove:hover {
        background: rgba(0,0,0,0.08); color: var(--text, #2b2620);
      }
      .field-files .file-add {
        appearance: none;
        display: inline-flex; align-items: center; gap: 8px;
        padding: 9px 14px;
        background: transparent;
        border: 1.5px dashed var(--border, #c9bda7);
        border-radius: 999px;
        font-size: 14px; color: var(--text, #2b2620);
        cursor: pointer;
        transition: border-color 120ms ease, background 120ms ease;
      }
      .field-files .file-add:hover {
        border-color: var(--text, #2b2620);
        background: rgba(0,0,0,0.03);
      }
      .field-files .file-add-plus {
        font-size: 16px; line-height: 1; color: var(--muted, #6b6258);
      }
      .field textarea {
        width: 100%; padding: 14px 16px;
        border: 1px solid var(--line, #d8cdb8); background: var(--bg, #f4ecdc);
        border-radius: 10px; font: inherit; font-size: 15.5px; line-height: 1.55;
        color: var(--ink, #2b2620);
        min-height: 132px; resize: vertical;
        transition: border-color .25s ease;
        font-family: inherit;
      }
      .field textarea:focus { outline: none; border-color: var(--ink, #2b2620); }
      .field textarea.err { border-color: #b14a2c; }
    `;
    document.head.appendChild(style);
  }

  // --- Constants (mirror api/config.example.php) -----------------------------
  const FORM_MAX_BYTES = 8 * 1024 * 1024; // 8 MB per file
  const FORM_MAX_FILES = 3;
  const FORM_ALLOWED_EXT = ['jpg', 'jpeg', 'png', 'webp', 'heic', 'heif', 'pdf'];
  const FORM_ALLOWED_ACCEPT = '.jpg,.jpeg,.png,.webp,.heic,.heif,.pdf,image/jpeg,image/png,image/webp,image/heic,image/heif,application/pdf';

  // --- uuid v4 (no crypto.randomUUID for old Safari) -------------------------
  function uuidV4() {
    const bytes = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0'));
    return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`;
  }

  function sessionKey(formId) {
    return `solara_form_session_${formId || 'main'}`;
  }

  function loadSession(formId) {
    try {
      const v = localStorage.getItem(sessionKey(formId));
      if (v && /^[0-9a-f-]{36}$/i.test(v)) return v;
    } catch (e) { /* localStorage unavailable */ }
    const fresh = uuidV4();
    try { localStorage.setItem(sessionKey(formId), fresh); } catch (e) {}
    return fresh;
  }

  function clearSession(formId) {
    try { localStorage.removeItem(sessionKey(formId)); } catch (e) {}
  }

  // --- UTM / referrer capture (one-time, persisted) --------------------------
  // Parsed once per page load. Used as request fields on every track + submit
  // call so the lead row gets first-touch attribution.
  function readAttribution() {
    const url = new URL(location.href);
    const q = url.searchParams;
    return {
      page_url:     location.href,
      referrer:     document.referrer || '',
      utm_source:   q.get('utm_source')   || '',
      utm_medium:   q.get('utm_medium')   || '',
      utm_campaign: q.get('utm_campaign') || '',
      utm_content:  q.get('utm_content')  || '',
      utm_term:     q.get('utm_term')     || '',
    };
  }

  // --- useFormSession --------------------------------------------------------
  // Returns { sessionId, track, formStartedAt, secondsOnForm } for a given
  // formId. `track` is debounced ~600ms so typing doesn't flood the endpoint;
  // step transitions call track() and the debounce coalesces into one POST.
  function useFormSession(formId) {
    const sessionIdRef = useRef(null);
    const startedAtRef = useRef(null);
    const timerRef = useRef(null);
    const attribution = useMemo(() => readAttribution(), []);

    if (sessionIdRef.current === null) sessionIdRef.current = loadSession(formId);
    if (startedAtRef.current === null) startedAtRef.current = Date.now();

    const track = useCallback((body) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      const sessionId = sessionIdRef.current;
      const startedAt = startedAtRef.current;
      timerRef.current = setTimeout(() => {
        const time_on_form = Math.max(0, Math.round((Date.now() - startedAt) / 1000));
        fetch('/api/track.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            session_id: sessionId,
            form_id: formId,
            time_on_form,
            ...attribution,
            ...body,
          }),
        }).catch(() => { /* tracking is best-effort; swallow errors */ });
      }, 600);
    }, [formId, attribution]);

    return {
      sessionId: sessionIdRef.current,
      track,
      attribution,
      startedAt: startedAtRef.current,
    };
  }

  // --- submitLead ------------------------------------------------------------
  // Multipart POST to /api/submit.php. files is an array of File objects.
  // Returns { ok: true, lead_id, email_sent } on success, throws on failure.
  async function submitLead(args) {
    const { sessionId, formId, productInterest, fields, files, attribution, startedAt, lastField, stepReached } = args;
    const fd = new FormData();
    fd.append('session_id', sessionId);
    fd.append('form_id', formId);
    fd.append('product_interest', productInterest || '');
    fd.append('page_url', attribution.page_url);
    fd.append('referrer', attribution.referrer);
    fd.append('utm_source', attribution.utm_source);
    fd.append('utm_medium', attribution.utm_medium);
    fd.append('utm_campaign', attribution.utm_campaign);
    fd.append('utm_content', attribution.utm_content);
    fd.append('utm_term', attribution.utm_term);
    fd.append('last_field', lastField || '');
    fd.append('step_reached', String(stepReached || 0));
    fd.append('time_on_form', String(Math.max(0, Math.round((Date.now() - startedAt) / 1000))));
    fd.append('name', fields.name || '');
    fd.append('email', fields.email || '');
    fd.append('phone', fields.phone || '');
    fd.append('message', fields.message || '');
    fd.append('fields_data', JSON.stringify(fields.fields_data || {}));
    fd.append('fields_touched', JSON.stringify(fields.fields_touched || []));

    // Meta CAPI dedup: one event_id shared by the browser Pixel Lead event and
    // the server-side Conversions API Lead event (api/submit.php reads it).
    const eventId = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : 'lead.' + Date.now() + '.' + Math.random().toString(36).slice(2);
    fd.append('event_id', eventId);

    (files || []).forEach((f) => fd.append('files[]', f));

    const r = await fetch('/api/submit.php', {
      method: 'POST',
      credentials: 'same-origin',
      body: fd,
    });
    const j = await r.json().catch(() => null);
    if (!r.ok || !j || j.ok !== true) {
      const msg = (j && j.error) || `Submit failed (${r.status})`;
      throw new Error(msg);
    }

    // Browser Pixel Lead, deduplicated with the server-side event via eventID.
    // Optional: if the Pixel script is blocked/absent, the server event still
    // lands. Never block the submit on this.
    try {
      if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', { content_category: productInterest || '' }, { eventID: eventId });
      }
    } catch (e) { /* non-fatal */ }

    return j;
  }

  // --- File helpers ----------------------------------------------------------
  function fileExtOk(name) {
    const ext = (name.split('.').pop() || '').toLowerCase();
    return FORM_ALLOWED_EXT.includes(ext);
  }
  function formatBytes(n) {
    if (n < 1024) return `${n} B`;
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
    return `${(n / 1024 / 1024).toFixed(1)} MB`;
  }
  function validateFile(file, existingCount) {
    if (existingCount >= FORM_MAX_FILES) {
      return `Max ${FORM_MAX_FILES} files.`;
    }
    if (!fileExtOk(file.name)) {
      return `Only JPG, PNG, WebP, HEIC, or PDF.`;
    }
    if (file.size > FORM_MAX_BYTES) {
      return `Each file must be under ${Math.round(FORM_MAX_BYTES / 1024 / 1024)} MB. "${file.name}" is ${formatBytes(file.size)}.`;
    }
    return null;
  }

  // --- FileUploadField -------------------------------------------------------
  // Controlled component. `files` is an array of File; `setFiles` replaces it.
  // Shows a "+ Add files" trigger, accepted chips with × remove, and an inline
  // error line when a file is rejected.
  function FileUploadField({ files, setFiles, error }) {
    const inputRef = useRef(null);
    const [localErr, setLocalErr] = useState('');

    const onPick = (e) => {
      const picked = Array.from(e.target.files || []);
      const next = [...files];
      let firstErr = '';
      for (const f of picked) {
        const err = validateFile(f, next.length);
        if (err) { firstErr = firstErr || err; continue; }
        // Dedupe by name+size (best-effort).
        if (next.some((x) => x.name === f.name && x.size === f.size)) continue;
        next.push(f);
      }
      setFiles(next);
      setLocalErr(firstErr);
      // Reset the input so re-picking the same file fires onChange again.
      e.target.value = '';
    };

    const onRemove = (i) => {
      const next = files.slice();
      next.splice(i, 1);
      setFiles(next);
      setLocalErr('');
    };

    const remaining = FORM_MAX_FILES - files.length;
    const trigger = () => inputRef.current && inputRef.current.click();
    const onKey = (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); trigger(); }
    };

    return (
      <div className="field field-files">
        <label>Photos or floor plans (optional)</label>
        <div className="files-help">
          Up to {FORM_MAX_FILES} files, {Math.round(FORM_MAX_BYTES / 1024 / 1024)} MB each. JPG, PNG, WebP, HEIC, or PDF.
        </div>

        <input
          ref={inputRef}
          type="file"
          accept={FORM_ALLOWED_ACCEPT}
          multiple
          onChange={onPick}
          style={{position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0}}
          aria-hidden="true"
          tabIndex={-1}
        />

        <div className="files-list">
          {files.map((f, i) => (
            <div className="file-chip" key={`${f.name}-${f.size}-${i}`}>
              <span className="file-chip-name" title={f.name}>{f.name}</span>
              <span className="file-chip-size">{formatBytes(f.size)}</span>
              <button
                type="button"
                className="file-chip-remove"
                aria-label={`Remove ${f.name}`}
                onClick={() => onRemove(i)}
              >×</button>
            </div>
          ))}
          {remaining > 0 && (
            <button
              type="button"
              className="file-add"
              onClick={trigger}
              onKeyDown={onKey}
            >
              <span className="file-add-plus" aria-hidden="true">+</span>
              <span>{files.length === 0 ? 'Add files' : `Add another (${remaining} left)`}</span>
            </button>
          )}
        </div>

        {(localErr || error) && <div className="err-msg">{localErr || error}</div>}
      </div>
    );
  }

  // --- CommentUploadsStep ----------------------------------------------------
  // The "anything we should see?" step. Replaces the legacy slot picker.
  // Used by every WizardForm via getCommentUploadsStep().
  function CommentUploadsStep({ data, update, errors }) {
    return (
      <div className="field-stack">
        <div className="field">
          <label>Anything we should know? (optional)</label>
          <textarea
            rows={5}
            placeholder="Site quirks, ideas, photos coming separately, deadlines, anything that helps us prep."
            value={data.message || ''}
            onChange={(e) => update('message', e.target.value)}
          />
        </div>
        <FileUploadField
          files={data.files || []}
          setFiles={(next) => update('files', next)}
          error={errors.files}
        />
      </div>
    );
  }

  // --- Shared step renderers (used by every wizard form) --------------------
  // StepPostal: postal code + property type. Validation: Canadian postal.
  function StepPostal({ data, update, errors }) {
    return (
      <div className="field-stack">
        <div className="field">
          <label>Postal code</label>
          <input
            placeholder="M5V 2T6"
            value={data.postal || ''}
            onChange={(e) => update('postal', e.target.value)}
            className={errors.postal ? 'err' : ''}
          />
          {errors.postal && <div className="err-msg">{errors.postal}</div>}
        </div>
        <div className="field">
          <label>Property type</label>
          <div className="seg">
            {['Residential', 'Commercial'].map((v) => (
              <button
                key={v}
                type="button"
                className={data.venue === v ? 'on' : ''}
                onClick={() => update('venue', v)}
              >{v}</button>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // StepWhen: timing dropdown buttons.
  function StepWhen({ data, update, errors }) {
    return (
      <div className="opts">
        {['1–3 months', '3–6 months', '6–12 months', 'Just researching'].map((v) => (
          <button
            key={v}
            type="button"
            className={`opt ${data.when === v ? 'sel' : ''}`}
            onClick={() => update('when', v)}
          >
            <span>{v}</span>
            <span className="dot" />
          </button>
        ))}
        {errors.when && <div className="err-msg">{errors.when}</div>}
      </div>
    );
  }

  // StepContact: name + email + phone + preferred contact channel.
  function StepContact({ data, update, errors }) {
    return (
      <div className="field-stack">
        <div className="field">
          <label>Name</label>
          <input
            placeholder="Jane Tremblay"
            value={data.name || ''}
            onChange={(e) => update('name', e.target.value)}
            className={errors.name ? 'err' : ''}
          />
          {errors.name && <div className="err-msg">{errors.name}</div>}
        </div>
        <div className="field-row">
          <div className="field">
            <label>Email</label>
            <input
              placeholder="jane@email.com"
              value={data.email || ''}
              onChange={(e) => update('email', e.target.value)}
              className={errors.email ? 'err' : ''}
            />
            {errors.email && <div className="err-msg">{errors.email}</div>}
          </div>
          <div className="field">
            <label>Phone</label>
            <input
              placeholder="647 555 0123"
              value={data.phone || ''}
              onChange={(e) => update('phone', e.target.value)}
              className={errors.phone ? 'err' : ''}
            />
            {errors.phone && <div className="err-msg">{errors.phone}</div>}
          </div>
        </div>
        <div className="field">
          <label>Preferred contact</label>
          <div className="seg">
            {['Phone', 'Email', 'Text'].map((v) => (
              <button
                key={v}
                type="button"
                className={data.contactPref === v ? 'on' : ''}
                onClick={() => update('contactPref', v)}
              >{v}</button>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Standard validators for the shared steps. Each form composes them into its
  // step list via the validate field; centralising them here keeps the rules
  // identical across the 5 wizard forms.
  function validatePostal(d) {
    return isCanadianPostalCode(d.postal) ? {} : { postal: 'Enter a valid Canadian postal code.' };
  }
  function validateWhen(d) {
    return d.when ? {} : { when: 'Pick a timing.' };
  }
  function validateContact(d) {
    const e = {};
    if (!String(d.name || '').trim()) e.name = 'Your name, please.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email || '')) e.email = 'Valid email, please.';
    if (!/^[\d\s\-+()]{10,}$/.test(d.phone || '')) e.phone = 'Valid phone, please.';
    return e;
  }

  function getCommentUploadsStep(opts) {
    const o = opts || {};
    return {
      id: 'uploads',
      title: o.title || 'Anything we should see?',
      sub:   o.sub   || "Drop a few photos of your space if you have them. Or just hit send, we'll talk it through on the call.",
      render: CommentUploadsStep,
      // No validation: comment + uploads are both optional.
      validate: () => ({}),
    };
  }

  // --- WizardForm ------------------------------------------------------------
  // Drives the form-card UI: progress bar, step transitions, validation, the
  // final "we'll be in touch within one business day" confirmation card.
  //
  // Props
  // - formId         : "main" | "pergolas" | "saunas" | "hottubs" | "swimspas"
  // - sectionId      : DOM id for the wrapping <section> (default "book")
  // - eyebrow        : top tag above the title (e.g. "Pergola consultation")
  // - title          : h2 text (e.g. "Two minutes. No pressure.")
  // - body           : paragraph under the title
  // - initialData    : initial form state
  // - steps          : array of { id, title, sub?, render, validate }
  //                    render({data, update, errors, toggleArr}) returns JSX.
  //                    validate(data) returns {field: msg} or {}.
  // - productInterest: string OR (data)=>string. Used on submit + tracking.
  // - confirmMeta    : (data)=>[{label, value}, ...] for the confirmation card.
  function WizardForm({
    formId,
    sectionId,
    eyebrow,
    title,
    body,
    initialData,
    steps,
    productInterest,
    confirmMeta,
  }) {
    const allSteps = useMemo(() => steps.concat([{ id: 'done', title: "We've got you.", sub: '', isConfirm: true }]), [steps]);
    const [step, setStep] = useState(0);
    const [data, setData] = useState(() => ({
      message: '',
      files: [],
      fields_touched: [],
      ...(initialData || {}),
    }));
    const [errors, setErrors] = useState({});
    const [direction, setDirection] = useState(1);
    const [submitting, setSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const session = useFormSession(formId);

    const update = useCallback((k, v) => {
      setData((d) => {
        const touched = d.fields_touched && d.fields_touched.includes(k) ? d.fields_touched : [...(d.fields_touched || []), k];
        const next = { ...d, [k]: v, fields_touched: touched };
        // Track on each user edit, debounced.
        const productInt = typeof productInterest === 'function' ? productInterest(next) : productInterest;
        session.track({
          name: next.name || '',
          email: next.email || '',
          phone: next.phone || '',
          product_interest: productInt || '',
          message: next.message || '',
          fields_data: serializeFields(next),
          fields_touched: next.fields_touched,
          last_field: k,
          step_reached: step,
        });
        return next;
      });
    }, [productInterest, session, step]);

    const toggleArr = useCallback((k, v) => {
      setData((d) => {
        const arr = (d[k] || []).includes(v)
          ? (d[k] || []).filter((x) => x !== v)
          : [...(d[k] || []), v];
        const touched = d.fields_touched && d.fields_touched.includes(k) ? d.fields_touched : [...(d.fields_touched || []), k];
        const next = { ...d, [k]: arr, fields_touched: touched };
        const productInt = typeof productInterest === 'function' ? productInterest(next) : productInterest;
        session.track({
          name: next.name || '',
          email: next.email || '',
          phone: next.phone || '',
          product_interest: productInt || '',
          message: next.message || '',
          fields_data: serializeFields(next),
          fields_touched: next.fields_touched,
          last_field: k,
          step_reached: step,
        });
        return next;
      });
    }, [productInterest, session, step]);

    const validateStep = useCallback((i, d) => {
      const s = steps[i];
      if (!s || !s.validate) return {};
      const e = s.validate(d) || {};
      setErrors(e);
      return e;
    }, [steps]);

    const next = useCallback(() => {
      const e = validateStep(step, data);
      if (Object.keys(e).length > 0) return;
      setDirection(1);
      setStep((s) => Math.min(allSteps.length - 1, s + 1));
    }, [step, data, validateStep, allSteps.length]);

    const back = useCallback(() => {
      setDirection(-1);
      setStep((s) => Math.max(0, s - 1));
    }, []);

    const total = steps.length; // confirm step is index === total
    const onBookable = step < total;
    const isLastInput = step === total - 1;
    const progress = onBookable ? step / total : 1;

    const doSubmit = useCallback(async () => {
      // Validate the final input step before submitting.
      const e = validateStep(step, data);
      if (Object.keys(e).length > 0) return;
      setSubmitting(true);
      setSubmitError('');
      try {
        const productInt = typeof productInterest === 'function' ? productInterest(data) : productInterest;
        await submitLead({
          sessionId: session.sessionId,
          formId,
          productInterest: productInt,
          fields: {
            name: data.name || '',
            email: data.email || '',
            phone: data.phone || '',
            message: data.message || '',
            fields_data: serializeFields(data),
            fields_touched: data.fields_touched || [],
          },
          files: data.files || [],
          attribution: session.attribution,
          startedAt: session.startedAt,
          lastField: 'submit',
          stepReached: step + 1,
        });
        // On success, clear the session so the next visit starts fresh.
        clearSession(formId);
        setSubmitted(true);
        setDirection(1);
        setStep(allSteps.length - 1);
      } catch (err) {
        setSubmitError(err && err.message ? err.message : 'Could not submit. Please try again or call us.');
      } finally {
        setSubmitting(false);
      }
    }, [data, step, validateStep, session, formId, productInterest, allSteps.length]);

    const current = allSteps[step];
    const isConfirm = current && current.isConfirm;
    const StepRender = !isConfirm && steps[step] && steps[step].render;

    return (
      <section className="form-section" id={sectionId || 'book'}>
        <div className="wrap">
          <div className="form-head">
            <span className="eyebrow">{eyebrow}</span>
            <h2 className="h2">{title}</h2>
            {body && <p className="body-lg">{body}</p>}
          </div>

          <div className="form-card">
            <div className="form-progress">
              <div className="form-progress-bar" style={{ width: `${progress * 100}%` }} />
              <div className="form-progress-meta">
                <span>{onBookable ? `Step ${step + 1} of ${total}` : 'Sent'}</span>
                {step > 0 && onBookable && (
                  <button type="button" className="back-btn" onClick={back}>← Back</button>
                )}
              </div>
            </div>

            <div className="form-stage">
              <div key={step} className={`step ${direction > 0 ? 'fwd' : 'back'}`}>
                <h3 className="step-title">{current ? current.title : ''}</h3>
                {current && current.sub && <p className="step-sub">{current.sub}</p>}

                {!isConfirm && StepRender && (
                  <StepRender
                    data={data}
                    update={update}
                    toggleArr={toggleArr}
                    errors={errors}
                  />
                )}

                {isConfirm && submitted && (
                  <ConfirmCard data={data} confirmMeta={confirmMeta} />
                )}

                {submitError && (
                  <div className="err-msg" style={{ marginTop: 12 }}>{submitError}</div>
                )}
              </div>
            </div>

            {onBookable && (
              <div className="form-foot">
                <div className="form-foot-meta">
                  {/* Per-step summary chip, left for the page to fill if needed */}
                </div>
                {isLastInput ? (
                  <button
                    type="button"
                    className="btn dark"
                    onClick={doSubmit}
                    disabled={submitting}
                  >
                    {submitting ? 'Sending…' : 'Send'}
                    <span className="arrow">→</span>
                  </button>
                ) : (
                  <button type="button" className="btn dark" onClick={next}>
                    Continue
                    <span className="arrow">→</span>
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }

  function ConfirmCard({ data, confirmMeta }) {
    const meta = (typeof confirmMeta === 'function') ? (confirmMeta(data) || []) : [];
    return (
      <div className="confirm">
        <div className="check-circle">✓</div>
        <h3 className="confirm-title">We'll be in touch within one business day.</h3>
        <p className="confirm-body">
          A confirmation is on its way to <b>{data.email || 'your inbox'}</b>.
          Bring photos of your space if you didn't already attach any. It makes the call ten times more useful.
        </p>
        {meta.length > 0 && (
          <div className="confirm-meta">
            {meta.map((m, i) => (
              <div key={i}><span>{m.label}</span><b>{m.value}</b></div>
            ))}
          </div>
        )}
        <a className="btn dark" href="tel:6477990439">Call us now · 647 799-0439 <span className="arrow">↗</span></a>
      </div>
    );
  }

  // Strip File objects out of fields_data so JSON.stringify doesn't choke.
  function serializeFields(d) {
    const out = {};
    for (const k of Object.keys(d)) {
      const v = d[k];
      if (k === 'files') {
        out.files = (v || []).map((f) => ({ name: f.name, size: f.size, type: f.type }));
      } else if (k === 'fields_touched') {
        // Skip, sent separately.
        continue;
      } else if (v instanceof File) {
        continue;
      } else {
        out[k] = v;
      }
    }
    return out;
  }

  // --- Postal-code helper, used by several step.validate() functions ----------
  function isCanadianPostalCode(s) {
    const pc = String(s || '').trim().toUpperCase().replace(/\s/g, '');
    return /^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(pc);
  }

  // --- Expose to global ------------------------------------------------------
  const exports = {
    WizardForm,
    FileUploadField,
    CommentUploadsStep,
    getCommentUploadsStep,
    StepPostal,
    StepWhen,
    StepContact,
    validatePostal,
    validateWhen,
    validateContact,
    submitLead,
    useFormSession,
    isCanadianPostalCode,
    formatBytes,
    FORM_MAX_BYTES,
    FORM_MAX_FILES,
    FORM_ALLOWED_EXT,
  };
  // Expose to both window (browser) and globalThis (Node vm sandbox during
  // prerender). In the browser, window === globalThis so the second assign
  // is a noop but harmless.
  Object.assign(window, exports);
  if (typeof globalThis !== 'undefined') Object.assign(globalThis, exports);
})();


/* === solara-sections.jsx === */
// Solara Living. Additional sections: stats, form, gallery, commercial, final CTA, footer

const { useState: useS2, useEffect: useE2, useRef: useR2, useMemo: useM2 } = React;

// _C / _CA helpers live in solara-form.jsx (loaded before this file in every
// home-page bundle per build.mjs PAGES config).

// ---------------- Animated Stats ----------------
function StatsRow(){
  const ref = useR2(null);
  const [animated, setAnimated] = useS2(false);
  // Stats mix one fact per product: pergolas, saunas, swim spas, plus a universal warranty line.
  // Sources: SunLouvre Features doc; Northern Leisure saunas and swim-spa collections; Lifetime Warranty PDF.
  const stats = useM2(() => {
    const fallback = [
      { num: 4000, suffix: "+",  label: "SunLouvre Pergolas projects since 2011" },
      { num: 17,   suffix: "",   label: "Northern Leisure sauna models" },
      { num: 16,   suffix: " ft",label: "Largest North Stream swim spa" },
      { num: 0,    suffix: "",   label: "Structural warranty", display: "Lifetime" },
    ];
    const cms = _CA('home.stats', null);
    if (!cms) return fallback;
    return cms.map((s, i) => ({
      num:     typeof s.num === 'number' ? s.num : fallback[i]?.num ?? 0,
      suffix:  s.suffix ?? fallback[i]?.suffix ?? "",
      label:   s.label  ?? fallback[i]?.label  ?? "",
      display: s.display || fallback[i]?.display,
    }));
  }, []);
  const eyebrow = _C('home.statsEyebrow', 'By the numbers');

  useE2(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          setAnimated(true);
          io.disconnect();
        }
      });
    }, { threshold: 0.3 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section className="stats" ref={ref}>
      <div className="stats-bg">
        <div className="ph v-deck" style={{width:"100%",height:"100%"}} />
        <div className="stats-veil" />
      </div>
      <div className="wrap stats-inner">
        <div className="stats-eyebrow">{eyebrow}</div>
        <div className="stats-grid">
          {stats.map((s, i) => (
            <Stat key={i} {...s} animated={animated} delay={i * 120} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Stat({ num, suffix, label, display, animated, delay }) {
  const [v, setV] = useS2(0);
  useE2(() => {
    if (!animated || display) return;
    let raf, start;
    const dur = 1400;
    const t0 = performance.now() + delay;
    const tick = (t) => {
      if (t < t0) { raf = requestAnimationFrame(tick); return; }
      if (start === undefined) start = t;
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setV(Math.round(num * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [animated]);
  return (
    <div className={`stat ${animated ? "in" : ""}`} style={{transitionDelay: `${delay}ms`}}>
      <div className="stat-num">
        {display ? display : <>{v.toLocaleString()}<span className="stat-suffix">{suffix}</span></>}
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
}

// ---------------- Lead Qualification Form ----------------
// Wizard mechanics live in solara-form.jsx (WizardForm). Each step below is a
// small render function that receives { data, update, toggleArr, errors } from
// the wizard and returns its JSX.

const HOME_CONSIDERING_OPTIONS = [
  { v: "Pergola",  src: "images/gallery/pergola-twilight.jpg" },
  { v: "Sauna",    src: "images/gallery/sauna-cabin-forest.jpg" },
  { v: "Hot tub",  src: "images/gallery/hot-tub-night-bokeh.jpg" },
  { v: "Swim spa", src: "images/gallery/swim-spa-courtyard.jpg" },
  { v: "Multiple", src: "images/gallery/backyard-pergola-tub.jpg" },
];

// Map the multi-select "considering" choice down to a single product_interest
// value the backend expects.
function deriveProductInterest(d) {
  const c = d.considering || [];
  if (c.length === 0) return '';
  if (c.length > 1 || c.includes('Multiple')) return 'multiple';
  const map = { 'Pergola': 'pergola', 'Sauna': 'sauna', 'Hot tub': 'hottub', 'Swim spa': 'swimspa' };
  return map[c[0]] || 'multiple';
}

function StepConsidering({ data, toggleArr, errors }) {
  const sel = data.considering || [];
  return (
    <div className="cards-grid">
      {HOME_CONSIDERING_OPTIONS.map((o) => (
        <button
          key={o.v}
          type="button"
          className={`photo-card ${sel.includes(o.v) ? "sel" : ""}`}
          onClick={() => toggleArr('considering', o.v)}
        >
          <img src={o.src} alt={o.v} loading="lazy" style={{display:"block", width:"100%", aspectRatio:"4/3", objectFit:"cover", borderRadius:"12px"}} />
          <div className="photo-card-meta">
            <span>{o.v}</span>
            <span className="check">{sel.includes(o.v) ? "✓" : "+"}</span>
          </div>
        </button>
      ))}
      {errors.considering && <div className="err-msg" style={{gridColumn:"1/-1"}}>{errors.considering}</div>}
    </div>
  );
}

function StepBudgetHome({ data, update, errors }) {
  const choices = ["Under $10k", "$10k - $20k", "$20k - $40k", "$40k+", "Not sure yet"];
  return (
    <div className="opts">
      {choices.map(v => (
        <button
          key={v}
          type="button"
          className={`opt ${data.budget === v ? "sel" : ""}`}
          onClick={() => update('budget', v)}
        >
          <span>{v}</span>
          <span className="dot" />
        </button>
      ))}
      {errors.budget && <div className="err-msg">{errors.budget}</div>}
    </div>
  );
}

function LeadForm() {
  const steps = useM2(() => [
    {
      id: 'considering', title: 'What are you considering?', sub: "Pick one or more. We'll tailor the conversation.",
      render: StepConsidering,
      validate: (d) => (!d.considering || d.considering.length === 0) ? { considering: 'Pick at least one.' } : {},
    },
    {
      id: 'where', title: 'Where is it going?', sub: 'Postal code helps us check delivery + permits.',
      render: StepPostal,
      validate: validatePostal,
    },
    {
      id: 'when', title: 'When are you hoping to install?', sub: "We're booking 6 to 10 weeks out for most builds.",
      render: StepWhen,
      validate: validateWhen,
    },
    {
      id: 'budget', title: 'Budget range?', sub: 'All-in, including delivery and install.',
      render: StepBudgetHome,
      validate: (d) => d.budget ? {} : { budget: 'Pick a budget range.' },
    },
    {
      id: 'contact', title: 'How can we reach you?', sub: 'Just the basics. We never share or sell.',
      render: StepContact,
      validate: validateContact,
    },
    getCommentUploadsStep(),
  ], []);
  return (
    <WizardForm
      formId="main"
      sectionId="book"
      eyebrow="Book a consultation"
      title="Two minutes. No pressure."
      body="Answer a few quick questions and we'll be in touch within one business day. Bring questions, photos, or just curiosity."
      initialData={{
        considering: [], postal: '', venue: 'Residential', when: '', budget: '',
        name: '', email: '', phone: '', contactPref: 'Phone',
      }}
      steps={steps}
      productInterest={deriveProductInterest}
      confirmMeta={(d) => [
        { label: 'Considering', value: (d.considering || []).join(', ') || '—' },
        { label: 'Postal',      value: String(d.postal || '').toUpperCase() || '—' },
        { label: 'Budget',      value: d.budget || '—' },
        { label: 'Contact',     value: d.contactPref || '—' },
      ]}
    />
  );
}

// ---------------- Gallery ----------------
function Gallery() {
  const ref = useR2(null);
  const [parallax, setParallax] = useS2(0);
  const [openIdx, setOpenIdx] = useS2(null);
  const touchStartX = useR2(null);

  // 7 photos, scattered. x/y in % of container, w/h in px, src, caption, parallax depth
  const items = [
    {x: 4,  y: 8,  w:280, h:340, src:"images/gallery/pergola-modern-house.jpg", caption:"Pergola · Oakville",         depth: 0.6, rot:-2},
    {x:38,  y: 0,  w:220, h:280, src:"images/gallery/sauna-cabin-forest.jpg",   caption:"Sauna · Forest Hill",        depth: 0.3, rot: 1},
    {x:70,  y:14,  w:260, h:180, src:"images/gallery/hot-tub-sunset.jpg",       caption:"Hot tub · Mississauga",      depth: 0.8, rot: 3},
    {x:14,  y:48,  w:200, h:260, src:"images/gallery/pergola-twilight.jpg",     caption:"Firepit lounge · Etobicoke", depth: 0.5, rot:-3},
    {x:50,  y:42,  w:300, h:200, src:"images/gallery/pergola-glass-deck.jpg",   caption:"Deck + pergola · Markham",   depth: 0.2, rot: 1},
    {x:78,  y:52,  w:200, h:240, src:"images/gallery/pergola-stone-house.jpg",  caption:"Cabana · Vaughan",           depth: 0.7, rot:-2},
    {x:30,  y:78,  w:240, h:170, src:"images/gallery/swim-spa-courtyard.jpg",   caption:"Swim spa · Burlington",      depth: 0.4, rot: 2},
  ];

  useE2(() => {
    const el = ref.current;
    if (!el) return;
    let raf;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const r = el.getBoundingClientRect();
        const t = Math.max(-1, Math.min(1, (window.innerHeight/2 - (r.top + r.height/2)) / window.innerHeight));
        setParallax(t);
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {passive:true});
    return () => { window.removeEventListener("scroll", onScroll); cancelAnimationFrame(raf); };
  }, []);

  // Body scroll lock + keyboard nav while lightbox open
  useE2(() => {
    if (openIdx === null) return;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") setOpenIdx(null);
      else if (e.key === "ArrowLeft") setOpenIdx((i) => (i - 1 + items.length) % items.length);
      else if (e.key === "ArrowRight") setOpenIdx((i) => (i + 1) % items.length);
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [openIdx, items.length]);

  const prev = (e) => { e && e.stopPropagation(); setOpenIdx((i) => (i - 1 + items.length) % items.length); };
  const next = (e) => { e && e.stopPropagation(); setOpenIdx((i) => (i + 1) % items.length); };
  const close = (e) => { e && e.stopPropagation(); setOpenIdx(null); };

  const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(dx) > 50) {
      if (dx < 0) next(); else prev();
    }
    touchStartX.current = null;
  };

  return (
    <section className="gallery" id="gallery" ref={ref}>
      <div className="wrap gallery-head">
        <span className="eyebrow">Selected projects</span>
        <h2 className="h2">A few we're proud of.</h2>
        <p className="body-lg" style={{maxWidth:"42ch"}}>
          Real installs across the GTA. From Oakville lakefronts to Markham townhomes.
        </p>
      </div>
      <div className="gallery-canvas">
        {items.map((it, i) => (
          <div
            key={i}
            className="gallery-tile"
            style={{
              left: `${it.x}%`,
              top: `${it.y}%`,
              width: `${it.w}px`,
              height: `${it.h}px`,
              transform: `translateY(${-parallax * 80 * it.depth}px) rotate(${it.rot}deg)`,
            }}
            role="button"
            tabIndex={0}
            onClick={() => setOpenIdx(i)}
            onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpenIdx(i); } }}
            aria-label={`Open ${it.caption} full size`}
          >
            <img src={it.src} alt={it.caption} loading="lazy" style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:"14px",display:"block",pointerEvents:"none"}} />
            <div className="gallery-cap">{it.caption}</div>
          </div>
        ))}
      </div>

      {openIdx !== null && (
        <div
          className="lightbox"
          role="dialog"
          aria-modal="true"
          aria-label={items[openIdx].caption}
          onClick={close}
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          <button type="button" className="lightbox-btn lightbox-close" onClick={close} aria-label="Close">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
          </button>
          <button type="button" className="lightbox-btn lightbox-prev" onClick={prev} aria-label="Previous image">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
          <button type="button" className="lightbox-btn lightbox-next" onClick={next} aria-label="Next image">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
          <figure className="lightbox-stage" onClick={(e) => e.stopPropagation()}>
            <img className="lightbox-img" src={items[openIdx].src} alt={items[openIdx].caption} />
            <figcaption className="lightbox-cap">
              <span>{items[openIdx].caption}</span>
              <span className="lightbox-counter">{openIdx + 1} / {items.length}</span>
            </figcaption>
          </figure>
        </div>
      )}
    </section>
  );
}

// ---------------- Commercial dark section ----------------
function Commercial() {
  const eyebrow = _C('home.commercial.eyebrow', 'Commercial track');
  const headingRaw = _C('home.commercial.heading', 'Built for restaurants,\nresorts, and developments.');
  const headingHtml = String(headingRaw).replace(/\n/g, '<br/>');
  const subheading = _C('home.commercial.subheading',
    'Outdoor seating that earns its square footage. Wellness amenities that fill bookings. Site-wide pergola systems for multi-residential developments. We handle the spec, the permits, and the install.');
  const cards = _CA('home.commercial.cards', [
    {title:"Restaurants",        description:"Year-round patios. Heated, louvered, branded."},
    {title:"Golf & resorts",     description:"Wellness barns and bar pavilions, on schedule."},
    {title:"Multi-residential",  description:"Rooftop decks and amenity spaces, spec'd to bylaw."},
  ]);
  const ctaLabel = _C('home.commercial.ctaLabel', 'Talk to us about your commercial project');
  const ctaHref  = _C('home.commercial.ctaHref',  '#book');
  const bgVideoRef = useR2(null);
  // The commercial background is a full-screen decorative loop. On phones we
  // never load it (the poster image is enough); on larger screens we attach the
  // src once the page is idle so it doesn't compete with the hero for bandwidth.
  // src is set imperatively so SSR and first client render match.
  useE2(() => {
    const v = bgVideoRef.current;
    if (!v || v.getAttribute('src')) return;
    if (!window.matchMedia || !window.matchMedia('(min-width: 721px)').matches) return;
    let started = false;
    const start = () => {
      const el = bgVideoRef.current;
      if (started || !el) return;
      started = true;
      el.muted = true;
      el.defaultMuted = true;
      el.playsInline = true;
      el.autoplay = true;
      // Sanity CDN — this host streams media at ~95 KB/s (see hero notes in
      // solara-app.jsx). CRF28 re-encode, 2.9 MB vs the 3.9 MB original.
      el.src = 'https://cdn.sanity.io/files/j9qyj311/production/06bb721cead697185175116c94cf0a73d69c3c9f.mp4';
      el.load();
      const p = el.play();
      if (p && p.catch) p.catch(() => {});
    };
    const ric = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500));
    const id = ric(start, { timeout: 3000 });
    return () => {
      if (window.cancelIdleCallback && typeof id === 'number') window.cancelIdleCallback(id);
    };
  }, []);
  return (
    <section className="commercial" id="commercial">
      <div className="commercial-bg">
        <video
          ref={bgVideoRef}
          poster="images/commercial-bg-poster.jpg"
          muted
          loop
          playsInline
          preload="none"
        />
      </div>
      <div className="wrap commercial-inner">
        <span className="eyebrow" style={{color:"rgba(247,242,234,.65)"}}>{eyebrow}</span>
        <h2 className="h2 commercial-title" dangerouslySetInnerHTML={{__html: headingHtml}} />
        <p className="commercial-sub">{subheading}</p>
        <div className="commercial-grid">
          {cards.map((c, i) => (
            <div className="commercial-card" key={c._key || i}>
              <div className="t">{c.title}</div>
              <div className="d">{c.description}</div>
            </div>
          ))}
        </div>
        <div className="commercial-cta">
          <a className="btn" href={ctaHref}>{ctaLabel} <span className="arrow">↗</span></a>
          <span className="commercial-phone">or call <b>{_C('site.phone', '647 799-0439')}</b></span>
        </div>
      </div>
    </section>
  );
}

// ---------------- FAQ (home) ----------------
// Mirrors the product-page FAQ accordion (same .p-faq-* class names so styling
// comes from the existing CSS). Reads home.faqItems from Sanity via _CA; if
// Sanity has nothing, the section renders nothing rather than a JSX fallback,
// so the matching FAQPage JSON-LD in prerender only fires when there is real
// visible content (Google's FAQ rich-result guideline).
function HomeFAQ(){
  const ref = useReveal();
  const [open, setOpen] = useS2(0);
  const cmsItems = _CA('home.faqItems', null);
  if (!cmsItems || !cmsItems.length) return null;
  const faqs = cmsItems.map((f) => ({q: f.question || f.q, a: f.answer || f.a}));
  const heading = _C('home.faqHeading', 'Everything we\nget asked first.');
  const headingHtml = String(heading).replace(/\n/g, '<br/>');
  const pergolasArea = _C('site.serviceArea.pergolasDisplay', 'GTA & Southern Ontario');
  const wetArea = _C('site.serviceArea.wetProductsDisplay', 'Vaughan & Toronto');
  return (
    <section className="p-faq-section" id="faq" ref={ref}>
      <div className="wrap">
        <div className="p-faq-grid">
          <div data-reveal>
            <span className="eyebrow" style={{display:"block", marginBottom:18}}>Common questions</span>
            <h2 className="h2" style={{margin:"0 0 18px 0", fontSize:"clamp(36px, 4.6vw, 64px)"}}
              dangerouslySetInnerHTML={{__html: headingHtml}}
            />
            <p className="body-lg" style={{margin:0, maxWidth:"36ch"}}>
              {faqs.length} questions covered. If yours is not here, we'll answer it on the consultation.
            </p>
            <p className="eyebrow" style={{marginTop:24, color:"var(--muted)", maxWidth:"36ch", lineHeight:1.7}}>
              Pergolas · {pergolasArea}<br/>
              Hot tubs · saunas · swim spas · {wetArea}
            </p>
          </div>
          <div className="p-faq-list" data-reveal>
            {faqs.map((f, i) => (
              <div key={i} className={`p-faq-item ${open === i ? "open" : ""}`}>
                <button type="button" className="p-faq-q" onClick={() => setOpen(open === i ? -1 : i)}>
                  <span>{f.q}</span>
                  <span className="pm">+</span>
                </button>
                <div className="p-faq-a">
                  <div className="p-faq-a-inner">{f.a}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ---------------- Final CTA ----------------
function FinalCTA() {
  const headingRaw = _C('home.cta.heading', 'Your backyard,\nfinished.');
  const headingHtml = String(headingRaw).replace(/\n/g, '<br/>');
  const subheading = _C('home.cta.subheading',
    "Book a 30-minute consultation. We'll walk your space, talk options, and send a fixed quote within 48 hours.");
  const buttonText = _C('home.cta.buttonText', 'Request a quote');
  const buttonLink = _C('home.cta.buttonLink', '#book');
  const phone = _C('site.phone', '647 799-0439');
  return (
    <section className="final-cta">
      <div className="wrap final-inner">
        <div className="final-eyebrow">· Solara Living · GTA ·</div>
        <h2 className="final-headline display" dangerouslySetInnerHTML={{__html: headingHtml}} />
        <p className="final-sub">{subheading}</p>
        <div className="final-actions">
          <a className="btn dark" href={buttonLink}>{buttonText} <span className="arrow">↗</span></a>
          <a className="btn ghost-dark" href={`tel:${String(phone).replace(/\D/g, '')}`}>{phone} <span className="arrow">→</span></a>
        </div>
      </div>
    </section>
  );
}

// ---------------- Footer ----------------
function Footer() {
  const tagline = _C('site.footerCopy',
    'Premium outdoor living. Designed, delivered, and installed across the GTA and southern Ontario.');
  const phone = _C('site.phone', '647 799-0439');
  const email = _C('site.salesEmail', 'info@solaraliving.ca');
  return (
    <footer className="footer">
      <div className="wrap footer-inner">
        <div className="footer-brand">
          <div className="wordmark">
            <img className="mark" src="images/solara-logo.svg" alt="" aria-hidden="true" />
            <span>SOLARA <b>LIVING</b></span>
          </div>
          <div className="small">{tagline}</div>
        </div>
        <div className="footer-cols">
          <div>
            <div className="col-h">Products</div>
            <a href="pergolas.html">Pergolas</a>
            <a href="saunas.html">Saunas</a>
            <a href="hot-tubs.html">Hot tubs</a>
            <a href="swim-spas.html">Swim spas</a>
          </div>
          <div>
            <div className="col-h">Company</div>
            <a href="#">About</a>
            <a href="#commercial">Commercial</a>
            <a href="#gallery">Projects</a>
          </div>
          <div>
            <div className="col-h">Get in touch</div>
            <a href={`tel:${String(phone).replace(/\D/g, '')}`}>{phone}</a>
            <a href={`mailto:${email}`}>{email}</a>
            <a href="#book">Book a consultation</a>
          </div>
          <div>
            <div className="col-h">Legal</div>
            <a href="privacy.html">Privacy policy</a>
          </div>
        </div>
      </div>
      <div className="wrap footer-base">
        <span>© {new Date().getFullYear()} Solara Living Inc.</span>
        <a className="footer-credit" href="https://allolumari.com" target="_blank" rel="noopener noreferrer">Coded and designed by allolumari</a>
        <span>Lifetime warranty · Designed in Canada</span>
      </div>
    </footer>
  );
}

Object.assign(window, { StatsRow, LeadForm, Gallery, Commercial, FinalCTA, Footer });


/* === solara-app.jsx === */
// Solara Living. Landing page (hero + 3 product sections + Why Solara)

const { useState, useEffect, useRef, useLayoutEffect, useMemo } = React;

const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
  "bgTone": "cream",
  "headlineWeight": 400,
  "scrollIntensity": "regular",
  "showImagery": true,
  "navOnDark": true
}/*EDITMODE-END*/;

// Photo-kind classnames preserve the original visual treatment (border, crop)
// of each product section while the rest of the content comes from Sanity.
const PRODUCT_SECTION_PHOTO_KINDS = ["v-pergola", "v-sauna", "v-tub"];

// Fallback used when Sanity is unreachable. Matches the legacy hardcoded copy
// from the original handoff.
const PRODUCT_SECTIONS_FALLBACK = [
  {
    anchor: "pergolas",
    eyebrow: "SunLouvre Pergolas",
    title: "Shade you control, by the degree.",
    body: "Bioclimatic aluminum pergolas with adjustable louvres. Open for sun, tilt for breeze, close for rain. Custom-built in Quebec, engineered for Ontario winters, and 100% waterproof when shut.",
    proofNum: "200 km/h",
    proofLabel: "Wind-tested. Lifetime warranty on aluminum and louvre mechanisms. 4,000+ installs since 2011.",
    ctaLabel: "Discover SunLouvre Pergolas",
    ctaHref: "pergolas.html",
    src: "images/pergola-main-page.jpg",
    alt: "White SunLouvre Pergolas adjustable-louvre pergola at dusk with string lights, fire feature, and lounge seating",
    reverse: false,
  },
  {
    anchor: "saunas",
    eyebrow: "Northern Leisure Saunas",
    title: "Canadian Red Cedar, precision-milled.",
    body: "Five sauna lines from Northern Leisure: barrel, cube, classic cabin, modern cabin, and panoramic. Canadian Red Cedar throughout. Electric wet/dry heater, heat-retaining rocks, and Wi-Fi remote activation come standard. 6 and 8 foot footprints, with an optional 2 foot porch.",
    proofNum: "From $9,997",
    proofLabel: "17 sauna configurations. Wi-Fi heater. Designed in Canada.",
    ctaLabel: "Discover Northern Leisure Saunas",
    ctaHref: "saunas.html",
    src: "images/sauna-main-page.jpg",
    alt: "Woman in a black swimsuit walking along a stone path toward a Canadian Red Cedar cabin sauna nestled among tall trees and wildflowers",
    reverse: true,
  },
  {
    anchor: "tubs",
    eyebrow: "Northern Leisure",
    title: "From plug-and-play to swim spas.",
    body: "Plug-and-play 120V hot tubs that run on a standard outlet. Premium 240V tubs with five-layer insulation, stainless steel frames, and Wi-Fi controls. North Stream all-season pools at 12, 14, 16, and 19 feet for swim, train, or soak. Designed in Ontario, supported by Canadian dealers.",
    proofNum: "120V – 240V",
    proofLabel: "From 3-seat plug-and-plays to 19-ft all-season pools.",
    ctaLabel: "Discover Northern Leisure Hot Tubs",
    ctaHref: "hot-tubs.html",
    src: "images/hot-tub-main-page.jpg",
    alt: "Northern Leisure premium hot tub on a wooden deck in misty forest, lid open showing jets and bubbling water, string lights overhead",
    reverse: false,
  },
];

const PRODUCT_SECTIONS = _CA('home.productSections', PRODUCT_SECTIONS_FALLBACK);

// ------- Floating pill nav -------
function Nav({ onDark }) {
  const [menuOpen, setMenuOpen] = useState(false);

  // Lock body scroll while drawer is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  // Close drawer on Escape
  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e) => { if (e.key === "Escape") setMenuOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  const close = () => setMenuOpen(false);
  const goBook = (e) => {
    e.preventDefault();
    close();
    document.getElementById('book')?.scrollIntoView({behavior:'smooth', block:'start'});
  };

  return (
    <>
      <div className={`nav ${onDark ? "on-dark" : ""}`}>
        <div className="nav-pill">
          <a href="#" className="nav-brand">
            <img className="mark" src="images/solara-logo.svg" alt="" aria-hidden="true" />
            <span>SOLARA <b>LIVING</b></span>
          </a>
          <a href="#" className="nav-link">Home</a>
          <a href="about.html" className="nav-link">About</a>
          <div className="nav-dropdown nav-link" style={{padding:0}}>
            <a href="#" className="nav-link" style={{display:"inline-flex", alignItems:"center", gap:6}}>
              Products
              <svg width="9" height="9" viewBox="0 0 10 10" fill="none"><path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </a>
            <div className="nav-dropdown-menu">
              <a href="pergolas.html">Pergolas</a>
              <a href="saunas.html">Saunas</a>
              <a href="hot-tubs.html">Hot tubs</a>
              <a href="swim-spas.html">Swim spas</a>
            </div>
          </div>
          <a href="contact.html" className="nav-link">Contact</a>
          <button
            type="button"
            className="nav-hamburger"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(o => !o)}
          >
            {menuOpen ? (
              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
            )}
          </button>
          <a href="#book" className="nav-cta" onClick={goBook}>{_C('home.hero.primaryButtonText', 'Request a quote')}</a>
        </div>
      </div>

      <div
        className={`nav-drawer-backdrop ${menuOpen ? "open" : ""}`}
        onClick={close}
        aria-hidden="true"
      />
      <div className={`nav-drawer ${menuOpen ? "open" : ""}`} role="dialog" aria-modal="true" aria-label="Site menu">
        <div className="nav-drawer-section">Navigate</div>
        <a href="#" className="nav-drawer-link active" onClick={close}>Home <span className="arrow">→</span></a>
        <a href="about.html" className="nav-drawer-link" onClick={close}>About <span className="arrow">→</span></a>
        <a href="contact.html" className="nav-drawer-link" onClick={close}>Contact <span className="arrow">→</span></a>
        <div className="nav-drawer-section">Products</div>
        <a href="pergolas.html" className="nav-drawer-link" onClick={close}>Pergolas <span className="arrow">→</span></a>
        <a href="saunas.html" className="nav-drawer-link" onClick={close}>Saunas <span className="arrow">→</span></a>
        <a href="hot-tubs.html" className="nav-drawer-link" onClick={close}>Hot tubs <span className="arrow">→</span></a>
        <a href="swim-spas.html" className="nav-drawer-link" onClick={close}>Swim spas <span className="arrow">→</span></a>
      </div>
    </>
  );
}

// ------- Hero with sticky scrub -------
function Hero({ scrollIntensity, onProgressChange }) {
  const heroRef = useRef(null);
  const cardRef = useRef(null);
  const heroVideoRef = useRef(null);
  const galleryRefs = useRef([]);
  const headlineRef = useRef(null);
  const subRef = useRef(null);
  const ctaRef = useRef(null);
  const tagRef = useRef(null);
  // Progress is tracked in the scroll handler and pushed to onProgressChange,
  // but never read in this component's render — so we keep it in a ref instead
  // of useState. Using setState here would re-render Hero on every scroll
  // frame, which on mobile creates a noticeable scroll-glitch (60+ React
  // renders/sec under flicks).
  const progressRef = useRef(0);

  // 6 floating gallery images positioned around the central card.
  // Layout (kind/w/h/x/y/rot) is fixed in code so the animation math works
  // consistently. Image source and alt text come from Sanity (window.__SOLARA_CONTENT__)
  // and fall back to hardcoded values when Sanity is unreachable.
  const floats = useMemo(() => {
    const cms = (typeof window !== "undefined" && window.__SOLARA_CONTENT__?.home?.heroFloats) || [];
    return [
      { kind:"v-pergola", w: 200, h: 140, x:-42, y:-32, rot: 0,
        src: cms[0]?.src || "images/hero-floats/v-pergola.jpg",
        alt: cms[0]?.alt || "White bioclimatic pergola at dusk with string lights and lounge seating" },
      { kind:"v-sauna",   w: 150, h: 200, x: 42, y:-30, rot: 0,
        src: cms[1]?.src || "images/hero-floats/v-sauna.jpg",
        alt: cms[1]?.alt || "Woman walking toward a cedar cabin sauna in a backyard garden" },
      { kind:"v-tub",     w: 220, h: 150, x:-38, y: 26, rot: 0,
        src: cms[2]?.src || "images/hero-floats/v-tub.jpg",
        alt: cms[2]?.alt || "Black aluminum pergola on a glass-railed deck at sunset" },
      { kind:"v-cream",   w: 140, h: 170, x: 40, y: 22, rot: 0,
        src: cms[3]?.src || "images/hero-floats/v-cream.jpg",
        alt: cms[3]?.alt || "Cedar barrel sauna detail framed by pine branches" },
      { kind:"v-fire",    w: 170, h: 120, x:-30, y:-44, rot: 0,
        src: cms[4]?.src || "images/hero-floats/v-fire.jpg",
        alt: cms[4]?.alt || "Black aluminum pergola at sunset over a pool" },
      { kind:"v-foliage", w: 160, h: 110, x: 32, y: 38, rot: 0,
        src: cms[5]?.src || "images/hero-floats/v-foliage.jpg",
        alt: cms[5]?.alt || "Black cedar barrel sauna nestled in a lush ornamental garden" },
    ];
  }, []);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;

    const intensityMul = scrollIntensity === "subtle" ? 0.6 : scrollIntensity === "dramatic" ? 1.25 : 1;

    let ticking = false;
    // Dirty-guard: skip DOM writes when t hasn't moved enough to be perceptible.
    // ~1 px on a 1000 px-tall hero. Cuts ~80% of style writes during slow scroll
    // on mobile (the cause of the "jittery during scroll" symptom on Chrome).
    let lastWrittenT = -1;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        const rect = el.getBoundingClientRect();
        const total = el.offsetHeight - window.innerHeight; // px scrub range
        const scrolled = -rect.top;
        const t = Math.max(0, Math.min(1, scrolled / total));
        progressRef.current = t;
        onProgressChange && onProgressChange(t);

        if (Math.abs(t - lastWrittenT) < 0.001) return;
        lastWrittenT = t;

        // Phase 1 (0 → 0.55): card shrinks from full-bleed to a centered card; copy fades up
        // Phase 2 (0.55 → 1): gallery floats settle in
        const p1 = Math.max(0, Math.min(1, t / 0.55));
        const p2 = Math.max(0, Math.min(1, (t - 0.4) / 0.6));

        // card sizing
        const card = cardRef.current;
        if (card) {
          // Use the sticky stage's actual size rather than window.innerHeight.
          // On iOS Safari with the URL bar visible, window.innerHeight reports
          // the small viewport while .hero-stage is 100lvh (large viewport),
          // which used to leave the hero-bg peeking out as a black band on top.
          const stage = card.parentNode;
          const startW = stage?.clientWidth || window.innerWidth;
          const startH = stage?.clientHeight || window.innerHeight;
          const endW = Math.min(720, startW * 0.46);
          const endH = Math.min(440, startH * 0.5);
          const w = startW + (endW - startW) * p1;
          const h = startH + (endH - startH) * p1;
          const r = 0 + 22 * p1;
          card.style.width = `${w}px`;
          card.style.height = `${h}px`;
          card.style.borderRadius = `${r}px`;
          card.style.boxShadow = `0 ${30 * p1}px ${80 * p1}px rgba(0,0,0,${0.28 * p1})`;
        }

        // headline / subtitle / cta fade out as we pass first phase
        const fadeOut = 1 - Math.max(0, Math.min(1, (t - 0.15) / 0.35));
        const lift = (1 - fadeOut) * 30;
        if (headlineRef.current){
          headlineRef.current.style.opacity = fadeOut;
          headlineRef.current.style.transform = `translateY(${-lift}px)`;
        }
        if (subRef.current){
          subRef.current.style.opacity = fadeOut;
          subRef.current.style.transform = `translateY(${-lift}px)`;
        }
        if (ctaRef.current){
          ctaRef.current.style.opacity = fadeOut;
          ctaRef.current.style.transform = `translateY(${-lift}px)`;
        }
        if (tagRef.current){
          tagRef.current.style.opacity = Math.max(0, 1 - p1 * 1.6);
        }

        // gallery floats: position interpolates from off-stage toward final, with parallax
        floats.forEach((f, i) => {
          const node = galleryRefs.current[i];
          if (!node) return;
          // delay per item
          const delay = i * 0.04;
          const localT = Math.max(0, Math.min(1, (p2 - delay) / (1 - delay)));
          const ease = 1 - Math.pow(1 - localT, 3);
          // start position: off-screen toward edges
          const dirX = Math.sign(f.x);
          const dirY = Math.sign(f.y);
          const startOffsetX = dirX * 60; // vw
          const startOffsetY = dirY * 40; // vh
          const cx = window.innerWidth / 2;
          const cy = window.innerHeight / 2;
          const finalLeft = cx + (f.x / 100) * window.innerWidth - f.w / 2;
          const finalTop  = cy + (f.y / 100) * window.innerHeight - f.h / 2;
          const startLeft = finalLeft + (startOffsetX / 100) * window.innerWidth * intensityMul;
          const startTop  = finalTop  + (startOffsetY / 100) * window.innerHeight * intensityMul;
          const left = startLeft + (finalLeft - startLeft) * ease;
          const top  = startTop  + (finalTop  - startTop)  * ease;
          node.style.width = `${f.w}px`;
          node.style.height = `${f.h}px`;
          node.style.left = `${left}px`;
          node.style.top = `${top}px`;
          node.style.transform = `rotate(${f.rot * ease}deg) scale(${0.9 + 0.1 * ease})`;
          node.style.opacity = ease;
        });
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive:true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [scrollIntensity, onProgressChange, floats]);

  // Defer the hero video so the poster image is the LCP. The element ships with
  // preload="none" and no src, so the browser fetches nothing up front. Shortly
  // after paint we attach the src and play it. Mobile autoplay is finicky, so we:
  //   1. force muted/playsInline as PROPERTIES (React's attrs alone aren't honored
  //      by the autoplay policy, which is why the video stuck on its first frame),
  //   2. wait until the media can actually start before calling play(),
  //   3. fall back to starting on the first user gesture if autoplay is still
  //      blocked (e.g. iOS Low Power Mode).
  // src is set imperatively so the SSR markup and first client render match.
  useEffect(() => {
    const el = heroVideoRef.current;
    if (!el || el.getAttribute("src")) return;
    let started = false;
    const start = () => {
      if (started || !el) return;
      started = true;
      el.muted = true;
      el.defaultMuted = true;
      el.playsInline = true;
      el.setAttribute("muted", "");
      el.setAttribute("playsinline", "");
      // Engine-driven autoplay: setting the autoplay PROPERTY before src puts
      // the media engine itself in charge of starting playback once data
      // arrives — the exact path iOS special-cases for muted playsinline
      // video (and the path the original eager markup used, which did play on
      // phones). A bare play() call on a preload="none" element with no data
      // yet is rejected by WebKit even when muted, because playback can't
      // start synchronously — that's what left the hero frozen on mobile.
      el.autoplay = true;
      // Videos are served from the Sanity CDN, NOT this host (2026-06-10): the
      // shared server streams media at ~95 KB/s, which starved every previous
      // fix — phones stalled on the first frame for minutes. cdn.sanity.io
      // (already serving all site images) delivers the same files in <1s.
      // Mobile gets a 1.6 MB 720p encode; desktop the full 3.4 MB 1080p.
      const smallScreen =
        window.matchMedia && window.matchMedia("(max-width: 720px)").matches;
      el.src = smallScreen
        ? "https://cdn.sanity.io/files/j9qyj311/production/5edde05974b5d117d07e957a40d2c6f304878a25.mp4"
        : "https://cdn.sanity.io/files/j9qyj311/production/fb8cc890da4e23f95956446ba87bced352a4d428.mp4";
      el.load();
      const tryPlay = () => {
        const p = el.play();
        if (p && p.catch) p.catch(() => {});
      };
      // Nudge engines that don't honor a late-set autoplay flag.
      el.addEventListener("loadeddata", tryPlay, { once: true });
      // If autoplay is still blocked (Low Power Mode etc.), retry on real taps.
      // touchend — not touchstart — is what iOS counts as user activation; a
      // touchstart that becomes a scroll never grants it, which is why the old
      // once-only touchstart/scroll retry burned itself out on the first
      // scroll without ever being allowed to play. These persist until the
      // video actually plays, then unbind.
      const kick = () => tryPlay();
      const evs = ["touchend", "pointerup", "click"];
      evs.forEach((t) => window.addEventListener(t, kick, { passive: true }));
      el.addEventListener(
        "playing",
        () => { evs.forEach((t) => window.removeEventListener(t, kick)); },
        { once: true }
      );
      tryPlay();
    };
    const ric = window.requestIdleCallback || ((fn) => setTimeout(fn, 200));
    const id = ric(start, { timeout: 1000 });
    return () => {
      if (window.cancelIdleCallback && typeof id === "number") window.cancelIdleCallback(id);
    };
  }, []);

  return (
    <section className="hero" ref={heroRef}>
      <div className="hero-stage">
        <div className="hero-bg" />

        {/* hero video card animates from full-bleed to centered */}
        <div className="video-card" ref={cardRef}>
          <video
            className="hero-video"
            ref={heroVideoRef}
            poster="images/hero-poster.jpg"
            muted
            loop
            playsInline
            preload="none"
          />
        </div>

        {/* floating gallery appears as we scroll */}
        {floats.map((f, i) => (
          <div
            key={i}
            className="gallery-img"
            ref={(el) => galleryRefs.current[i] = el}
          >
            <div className={`ph ${f.kind}${f.src ? " has-photo" : ""}`}>
              {f.src && <img className="ph-img" src={f.src} alt={f.alt} loading="eager" />}
            </div>
          </div>
        ))}

        {/* hero copy */}
        <div className="hero-copy">
          <div className="wrap">
            <div>
              <h1 ref={headlineRef} className="hero-headline display"
                dangerouslySetInnerHTML={{__html:
                  ((typeof window !== "undefined" && window.__SOLARA_CONTENT__?.home?.hero?.heading) || "Your backyard,\nfinished.")
                    .replace(/\n/g, "<br/>")
                }}
              />
            </div>
            <div style={{display:"flex", flexDirection:"column", alignItems:"flex-start", gap:6}}>
              <div ref={subRef} className="hero-sub">
                {(typeof window !== "undefined" && window.__SOLARA_CONTENT__?.home?.hero?.subheading) ||
                  "Bioclimatic pergolas. Saunas, hot tubs, and swim spas. Designed in Canada, installed across the GTA and southern Ontario."}
              </div>
              <div ref={ctaRef} className="hero-actions">
                <a className="btn" href="#book" onClick={(e)=>{e.preventDefault(); document.getElementById('book')?.scrollIntoView({behavior:'smooth', block:'start'});}}>
                  {(typeof window !== "undefined" && window.__SOLARA_CONTENT__?.home?.hero?.primaryButtonText) || "Request a quote"} <span className="arrow">↗</span>
                </a>
                <a className="btn ghost" href="#pergolas" onClick={(e)=>{e.preventDefault(); document.getElementById('pergolas')?.scrollIntoView({behavior:'smooth', block:'start'});}}>
                  {(typeof window !== "undefined" && window.__SOLARA_CONTENT__?.home?.hero?.secondaryButtonText) || "See products"} <span className="arrow">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="scroll-hint">
          {(typeof window !== "undefined" && window.__SOLARA_CONTENT__?.home?.hero?.scrollHint) || "scroll · 647 · 799 · 0439"}
        </div>
      </div>
    </section>
  );
}

// ------- Marquee strip between hero and products -------
function MarqueeStrip(){
  const items = _CA('home.marqueeItems', [
    "Lifetime structural warranty",
    "Designed in Canada",
    "GTA + southern Ontario service",
    "Authorized SunLouvre Pergolas + Northern Leisure dealer",
    "4,000+ SunLouvre Pergolas projects since 2011",
    "Residential + commercial",
  ]);
  const all = [...items, ...items, ...items];
  return (
    <div className="note-strip">
      <div className="marquee">
        {all.map((t,i)=>(<span key={i}><b>·</b>&nbsp; {t}</span>))}
      </div>
    </div>
  );
}

// ------- Partner logos strip -------
// Two authorized-dealer logos (SunLouvre Pergolas + Northern Leisure Products).
// Sanity-hosted PNGs, displayed at modest size with dimmed opacity to feel
// like a credibility footnote rather than a sales banner.
function PartnersStrip(){
  const nhtSrc = _C('home.partnerNhtSrc', 'https://cdn.sanity.io/images/j9qyj311/production/7eeea978b7b378009a989d8605e63bbde2c340b1-302x80.svg');
  const slpSrc = _C('home.partnerSlpSrc', 'https://cdn.sanity.io/images/j9qyj311/production/4a9e6129c54ba010caa5b85e27e6b70a203cfde3-600x287.png');
  return (
    <section className="partners-strip">
      <div className="wrap partners-strip-inner">
        <span className="eyebrow partners-eyebrow">Authorized dealer</span>
        <div className="partners-logos">
          <img className="partner-logo partner-logo-slp" src={slpSrc} alt="SunLouvre Pergolas" />
          <span className="partners-divider" aria-hidden="true">·</span>
          <img className="partner-logo partner-logo-nht" src={nhtSrc} alt="Northern Leisure Products" />
        </div>
      </div>
    </section>
  );
}

// ------- Reveal-on-scroll wrapper -------
function useReveal(){
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting){
          e.target.classList.add("in");
        }
      });
    }, { threshold: 0.2 });
    el.querySelectorAll('[data-reveal]').forEach(n => io.observe(n));
    return () => io.disconnect();
  }, []);
  return ref;
}

// ------- Product section -------
function ProductSection({ idx, total, eyebrow, title, body, proof, ctaLabel, ctaHref, photoKind, photoSrc, photoAlt, photoObjectPosition, reverse, anchor }){
  const ref = useReveal();
  return (
    <section className="product-section" id={anchor} ref={ref}>
      <div className="wrap">
        <div className={`product-row ${reverse ? "reverse" : ""}`}>
          <div className="product-photo" data-reveal>
            <div className={`ph ${photoKind}${photoSrc ? " has-photo" : ""}`}>
              {photoSrc ? (
                <img className="ph-img" src={photoSrc} alt={photoAlt || eyebrow} loading="lazy" style={photoObjectPosition ? {objectPosition: photoObjectPosition} : undefined} />
              ) : (
                <span className="ph-tag">{eyebrow.toLowerCase()} · 4×5</span>
              )}
            </div>
          </div>
          <div className="product-text" data-reveal>
            <span className="eyebrow">{eyebrow}</span>
            <h2 className="h2">{title}</h2>
            <p>{body}</p>
            <div className="proof">
              <div className="proof-num">{proof.num}</div>
              <div className="proof-label">{proof.label}</div>
            </div>
            <div className="product-cta-row">
              <a className="product-cta" href={ctaHref || "#book"}>
                {ctaLabel} <span className="arrow">→</span>
              </a>
              {ctaHref && (
                <a
                  className="product-cta-secondary"
                  href="#book"
                  onClick={(e)=>{e.preventDefault(); document.getElementById('book')?.scrollIntoView({behavior:'smooth', block:'start'});}}
                >
                  Request a quote <span className="arrow">↗</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ------- Why Solara -------
function WhySolara(){
  const ref = useReveal();
  const fallbackItems = [
    { title:"Lifetime warranty", body:"SunLouvre Pergolas carries a lifetime limited warranty on aluminum and louvre mechanisms. Northern Leisure premium hot tubs carry a lifetime structural guarantee." },
    { title:"Designed for Canadian winters", body:"SunLouvre Pergolas is built in Quebec. Northern Leisure is designed in Ontario for the True North." },
    { title:"Custom or standard", body:"Configure to your space, or pick a proven standard build." },
    { title:"Residential + commercial", body:"Restaurants, golf courses, multi-residential. Same care, larger scale." },
  ];
  // Number prefixes are display-only (01, 02, …) and live in the JSX, not the CMS.
  const items = _CA('home.whyPoints', fallbackItems).map((it, i) => ({
    num: String(i + 1).padStart(2, '0'),
    title: it.title,
    body: it.body,
  }));
  // Heading uses \n → <br/> so editors can break the line from a single string field.
  const headingRaw = _C('home.whyHeading', 'Built to outlast\nthe trend cycle.');
  const headingHtml = String(headingRaw).replace(/\n/g, '<br/>');
  const subheading = _C('home.whySubheading', 'Four reasons GTA homeowners and developers have chosen Solara.');
  return (
    <section className="why" id="why" ref={ref}>
      <div className="wrap">
        <div className="why-head">
          <h2 className="h2" data-reveal style={{transition:"none", opacity:1, transform:"none"}}
            dangerouslySetInnerHTML={{__html: headingHtml}}
          />
          <p data-reveal style={{transition:"none", opacity:1, transform:"none"}}>
            {subheading}
          </p>
        </div>
        <div className="why-grid">
          {items.map((it, i) => (
            <div className="why-item" key={i} data-reveal>
              <div className="num">{it.num}</div>
              <h3>{it.title}</h3>
              <p>{it.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ------- App -------
function App(){
  const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
  const [navDark, setNavDark] = useState(true);

  // bg tone via tweak
  useEffect(() => {
    const tones = {
      cream:  ["#F7F2EA","#EFE7DA"],
      sand:   ["#F1E9D9","#E5D9C2"],
      oat:    ["#EFEAE0","#E1D9C8"],
    };
    const [bg, bg2] = tones[t.bgTone] || tones.cream;
    document.documentElement.style.setProperty("--bg", bg);
    document.documentElement.style.setProperty("--bg-2", bg2);
  }, [t.bgTone]);

  // headline weight via tweak
  useEffect(() => {
    document.documentElement.style.setProperty("--display-weight", t.headlineWeight);
    document.querySelectorAll(".display, .h2").forEach(el => {
      el.style.fontWeight = t.headlineWeight;
    });
  }, [t.headlineWeight]);

  // nav dark when over hero. The hero scroll handler fires this on every
  // scroll frame — gate it through a ref so setNavDark only runs when the
  // threshold actually crosses, avoiding 60+ re-renders/sec under fast scrolls.
  const navDarkRef = useRef(true);
  const onHeroProgress = (p) => {
    const next = p < 0.85;
    if (next !== navDarkRef.current) {
      navDarkRef.current = next;
      setNavDark(next);
    }
  };

  return (
    <>
      <Nav onDark={navDark} />
      <Hero scrollIntensity={t.scrollIntensity} onProgressChange={onHeroProgress} />
      <MarqueeStrip />
      <PartnersStrip />
      {PRODUCT_SECTIONS.map((p, i) => (
        <ProductSection
          key={p.anchor || i}
          idx={i + 1} total={3}
          anchor={p.anchor}
          eyebrow={p.eyebrow}
          title={p.title}
          body={p.body}
          proof={{ num: p.proofNum, label: p.proofLabel }}
          ctaLabel={p.ctaLabel}
          ctaHref={p.ctaHref}
          photoKind={PRODUCT_SECTION_PHOTO_KINDS[i] || "v-pergola"}
          photoSrc={p.src}
          photoAlt={p.alt}
          reverse={!!p.reverse}
        />
      ))}
      <WhySolara />
      <StatsRow />
      <LeadForm />
      <Gallery />
      <Commercial />
      <HomeFAQ />
      <FinalCTA />
      <Footer />

      {/* Tweaks panel — dev-only. Visible on localhost or with ?edit in the URL. */}
      {(typeof window !== "undefined" &&
        (location.hostname === "localhost" ||
         location.hostname === "127.0.0.1" ||
         location.search.includes("edit"))) && (
      <TweaksPanel title="Tweaks">
        <TweakSection label="Surface" />
        <TweakRadio
          label="Background tone" value={t.bgTone}
          options={[
            {value:"cream", label:"Cream"},
            {value:"sand",  label:"Sand"},
            {value:"oat",   label:"Oat"},
          ]}
          onChange={(v) => setTweak("bgTone", v)}
        />
        <TweakSection label="Type" />
        <TweakRadio
          label="Headline weight" value={t.headlineWeight}
          options={[
            {value:300, label:"Light"},
            {value:400, label:"Regular"},
            {value:500, label:"Medium"},
          ]}
          onChange={(v) => setTweak("headlineWeight", v)}
        />
        <TweakSection label="Hero motion" />
        <TweakRadio
          label="Scroll-out intensity" value={t.scrollIntensity}
          options={[
            {value:"subtle",   label:"Subtle"},
            {value:"regular",  label:"Regular"},
            {value:"dramatic", label:"Dramatic"},
          ]}
          onChange={(v) => setTweak("scrollIntensity", v)}
        />
      </TweaksPanel>
      )}
    </>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
